import { render, staticRenderFns } from "./ModalAddC.vue?vue&type=template&id=2e3c1a1a&"
import script from "./ModalAddC.vue?vue&type=script&lang=js&"
export * from "./ModalAddC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports